import React, { useState } from "react";
import {
  Container,
  Stepper,
  Step,
  StepLabel,
  Button,
  Box,
  Typography
} from "@mui/material";

const COLORS = {
  success: "green",
  active: "#1976d2",
};

function Testing1() {
  const [activeStep, setActiveStep] = useState(0);

  const steps = [
    "Step 1",
    "Step 2",
    "Step 3",
    "Step 4",
    "Step 5",
  ];

  const handleNext = () => {
    setActiveStep((prev) => prev + 1);
  };

  const handleBack = () => {
    setActiveStep((prev) => prev - 1);
  };

  return (
    <Container>
      {/* Stepper */}
      <Stepper
        activeStep={activeStep}
        alternativeLabel
        sx={{
          mb: 2,
          mt: 1,
          width: "100%",
          overflow: "hidden",
          "& .MuiStepLabel-label": {
            fontSize: "0.8rem",
            "@media (max-width: 600px)": { fontSize: "0.60rem" },
          },
          "& .MuiSvgIcon-root": {
            width: "17px",
            height: "17px",
          },
          "& .MuiStepConnector-line": {
            minHeight: "2px",
          },
          "& .MuiStepLabel-root .Mui-completed": {
            color: COLORS.success,
          },
          "& .MuiStepLabel-root .Mui-active": {
            color: COLORS.active,
          },
          "& .MuiStepLabel-label.Mui-active": {
            fontWeight: "bold",
          },
        }}
      >
        {steps.map((label, index) => (
          <Step key={index}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      {/* Step Content */}
      <Box sx={{ mt: 3 }}>
        {activeStep === 0 && <Typography>Step 1 Content</Typography>}
        {activeStep === 1 && <Typography>Step 2 Content</Typography>}
        {activeStep === 2 && <Typography>Step 3 Content</Typography>}
        {activeStep === 3 && <Typography>Step 4 Content</Typography>}
        {activeStep === 4 && <Typography>Step 5 Content</Typography>}
      </Box>

      {/* Buttons */}
      <Box sx={{ mt: 3 }}>
        <Button
          disabled={activeStep === 0}
          onClick={handleBack}
          sx={{ mr: 1 }}
        >
          Back
        </Button>

        <Button
          variant="contained"
          onClick={handleNext}
          disabled={activeStep === steps.length - 1}
        >
          Next
        </Button>
      </Box>
    </Container>
  );
}

export default Testing1;